import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteMethod, getMethod, postMethod, putMethod, setAuthorizationToken } from "../../utils/apiServices";

export const getUserReports = createAsyncThunk("report/getUserReports", async (query) => {
  const response = await getMethod(`/api/admin/report/users`, query);
  return response;
});

export const getInventoryReports = createAsyncThunk("report/getInventoryReports", async ({ query, signal }) => {
  const response = await getMethod(`/api/admin/report/inventory`, query, { signal });
  return response;
});

const initialState = {
  userReports: { loading: false, success: false, error: false, data: null, type: "monthly" },
  inventoryReport: {
    type: "presale",
    filter: null,
    localFilter: null,
    limit: 25,
    loading: false,
    success: false,
    error: false,
    data: null,
    total: { total: 0, itemPerPage: 0, totalPages: 0 },
  },
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setInventoryType: (state, action) => {
      state.inventoryReport.type = action.payload;
    },
    setInventoryLimit: (state, action) => {
      state.inventoryReport.limit = action.payload;
    },
    setInventoryFilter: (state, action) => {
      state.inventoryReport.localFilter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserReports.pending, (state) => {
        state.userReports.loading = true;
        state.userReports.success = false;
        state.userReports.data = null;
        state.userReports.error = false;
      })
      .addCase(getUserReports.fulfilled, (state, action) => {
        state.userReports.loading = false;
        state.userReports.success = true;
        state.userReports.error = false;
        state.userReports.data = action.payload.data;
        state.userReports.type = action.payload.type;
      })
      .addCase(getUserReports.rejected, (state, action) => {
        state.userReports.loading = false;
        state.userReports.success = false;
        state.userReports.data = null;
        state.userReports.error = true;
      })
      .addCase(getInventoryReports.pending, (state) => {
        state.inventoryReport.loading = true;
        state.inventoryReport.success = false;
        state.inventoryReport.data = null;
        state.inventoryReport.error = false;
        state.inventoryReport.total = { total: 0, itemPerPage: 0, totalPages: 0 };
      })
      .addCase(getInventoryReports.fulfilled, (state, action) => {
        state.inventoryReport.loading = false;
        state.inventoryReport.success = true;
        state.inventoryReport.error = false;
        state.inventoryReport.data = action.payload.data;
        state.inventoryReport.filter = action.payload.filters;
        state.inventoryReport.total = {
          total: action.payload.total,
          currentPage: action.payload.currentPage,
          limit: action.payload.limit,
          itemPerPage: action.payload.itemPerPage,
          totalPages: action.payload.totalPages,
        };
      })
      .addCase(getInventoryReports.rejected, (state, action) => {
        state.inventoryReport.loading = false;
        state.inventoryReport.success = false;
        state.inventoryReport.data = null;
        state.inventoryReport.error = true;
      });
  },
});

export const { setInventoryType, setInventoryLimit, setInventoryFilter } = reportSlice.actions;

export default reportSlice.reducer;

export const getInventoryReportExport = (query) => async (dispatch) => {
  const response = await postMethod(`/api/admin/report/inventory/export`, query, { responseType: "blob" });
  return response;
};
